import React from 'react';

const MyQuizIframe = () => {
  return (
    <iframe
      src="https://myquiz.ge/poll/view/pM1I3k252CRkzg/"
      title="MyQuiz Poll"
      style={{ width: "100%", height: "600px", border: "none" }}
    >
      Your browser does not support iframes.
    </iframe>
  );
};

export default MyQuizIframe;
